import { Clock, MapPin, PackageCheck, Truck } from "lucide-react";
import { themeOf, tint } from "@/lib/mall";

/** Every shop's banner reads the same way: address · pickup · drop-off · shipping. Blanks hide. */
export default function OpsChips({ card, className = "", tiny = false, dark = false }) {
    if (!card) return null;
    const theme = themeOf(card);
    const ops = card.ops || {};
    const chips = [
        ops.address && { key: "address", icon: MapPin, label: ops.address },
        ops.pickup && { key: "pickup", icon: PackageCheck, label: ops.pickup_hours ? `Pickup · ${ops.pickup_hours}` : "Pickup" },
        ops.dropoff && { key: "dropoff", icon: Clock, label: "Drop-off" },
        ops.shipping && { key: "shipping", icon: Truck, label: ops.shipping },
    ].filter(Boolean);
    if (!chips.length) return null;

    return (
        <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid={`ops-${card.slug}`}>
            {chips.map((c) => (
                <span key={c.key} data-testid={`ops-${card.slug}-${c.key}`}
                    className={`inline-flex max-w-full items-center gap-1.5 rounded-full border px-3 py-1 font-mono uppercase tracking-[0.14em] ${tiny ? "text-[11px]" : "text-[11px]"}`}
                    style={dark
                        ? { borderColor: "rgba(255,255,255,0.18)", color: "#d4d4d8", background: "rgba(0,0,0,0.35)" }
                        : { borderColor: tint(theme.primary, 0.35), color: "#3f3f46", background: tint(theme.primary, 0.05) }}>
                    <c.icon size={tiny ? 9 : 11} className="shrink-0" />
                    <span className="truncate">{c.label}</span>
                </span>
            ))}
        </div>
    );
}
